<template>
    <v-app id="app">
        <button class="handbook-link_skipToContent hidden-print-only" v-on:click="skipToContentClick">Skip to content</button>
        
        <v-toolbar class="hidden-print-only" id="toolbar" dark fixed app clipped-left :height="this.isPrint ? '0px' : '85px'" width="250px" style="border-bottom:5px solid #BE8E57;">
            <v-toolbar-side-icon style="color: #BE8E57;" v-on:click.stop="toggleNav"></v-toolbar-side-icon>

            <router-link to="/"  class="handbook-link_link logo-link">
                <v-img :src="headerImage"  aspect-ratio="1.7" contain min-width="80px" :max-height="headerImageHeight" max-width="85px" 
                class="handbook-link_link mr-xs-0 handbook-header-img" style="margin-right:1rem;"></v-img>
            </router-link>
            <router-link to="/" class="handbook-link_link logo-link">
                <v-toolbar-title role="heading" aria-level="1" class="handbook-link_link">{{ title }}</v-toolbar-title>
            </router-link>

            <v-spacer></v-spacer>

            <v-img src="/images/handbook-logo.png" v-on:click="goToLibrary" style="height: 100%" max-height="60px" 
                min-width="250px" max-width="355px" contain  class="handbook-link_link hidden-sm-and-down"></v-img>
              
        </v-toolbar>

        <drawer class="hidden-print-only" v-model="drawer" v-on:focus-nav-drawer-link="navDrawerLinkFocus" />

        <button v-on:click="helpButtonClick" class="handbook-helpPanel hidden-print-only">
            <span class="handbook-link_help"><v-icon dark>contact_support</v-icon>&nbsp;Help</span>
        </button>
        <v-content id="handbook-content" tabindex="0" :class="contentClass">
            <v-fade-transition mode="out-in">
                <router-view :key="$route.fullPath" />
            </v-fade-transition>
        </v-content>

        <v-footer class="hidden-print-only pl-0" id="footer" height="60" style="border-top: 5px solid rgb(190, 142, 87);" dark app inset absolute>
            <div class="footer-items" style="width: 100%"> 
                <div>
                    &nbsp;&nbsp;
                    <a :href="accessibilityLink" target="_blank">Accessibility information</a>&nbsp;&nbsp;&nbsp;
                    <a :href="copyrightLink" target="_blank">Copyright information</a> &nbsp;&nbsp;&nbsp;
                    <a :href="disclaimerLink" target="_blank">Disclaimer</a> &nbsp;&nbsp;&nbsp;
                    <a :href="contactLink" target="_blank">Feedback</a> &nbsp;&nbsp;&nbsp;
                    <a :href="handbookHelp">Help</a>&nbsp;&nbsp;&nbsp;
                    <a v-on:click="dialog = true">Acknowledgement of Country</a>
                </div>
            </div>
            <img border="0" width="25" height="25" style="margin-right: 10px;width: 36px;height: 36px;float: right;" id="_x0000_i1026" src="https://www.aph.gov.au/-/media/05_About_Parliament/54_Parliamentary_Depts/544_Parliamentary_Library/branding/email/icon_parl_gold" 
            alt="Website icon" />
        </v-footer>
        <v-dialog dark v-model="dialog" width="60%">
            <v-card>
                <v-card-title class="headline  text-xs-center">Acknowledgement of Country</v-card-title>
                <v-card-text>
                    We acknowledge the traditional owners and custodians of country throughout Australia and acknowledge their continuing connection to land, waters and community. We pay our respects to the people, the cultures and the elders past, present and emerging.
                </v-card-text>
                <v-card-text>
                    Aboriginal and Torres Strait Islander people are advised that this website may contain names and images of deceased people.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="green lighten-1"
                           flat
                           v-on:click="addCulturalSensitivityCookie">
                           Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
    import Drawer from '@/components/Drawer.vue'
    import API from '@/mixins/HandbookAPI'
    import print from './mixins/print';

    export default {
        mixins: [print],
        data: () => ({
            drawer: false,
            accessibilityLink: `${API.AphUrl}/Help/Accessibility`,
            copyrightLink: `${API.AphUrl}/Help/Disclaimer_Privacy_Copyright#c`,
            disclaimerLink: `${API.AphUrl}/Help/Disclaimer_Privacy_Copyright#d`,
            contactLink: `${API.AphUrl}/Help/Contact`,
            helpLink: `/Help`,
            dialog: true
        }),

        methods: {
            goToHome() {
                this.$router.replace({ path: "/", query: {} }).catch(() => { });
            },
            goToLibrary() {
                window.open(API.LibraryUrl, '_blank');
            },
            goToHandbookHelp() {
                this.$router.push(this.handbookHelp)
            },
            addCulturalSensitivityCookie() {
                var secure = location.hostname !== 'localhost';
                this.$cookies.set('handbook_culturalSensitivityWarningSeen', 1, this.$moment(new Date()).add(99, 'years').toDate(), null, null, secure, 'strict');
                this.dialog = false;
            },
            toggleNav() {
                this.drawer = !this.drawer;
            },

            helpButtonClick() {

                let label = 'help'
                if (this.currentSection) {
                    label = `help - ${this.currentSection}`
                }

                this.$gtag.event('help pop-in click', {
                    'event_category': 'click',
                    'event_label': label,
                    'value': 1
                });

                this.goToHandbookHelp();
            },

            skipToContentClick() {
                window.setTimeout(() => {
                    const heading = document.querySelector('#handbook-content');
                    const topPos = heading.getBoundingClientRect().top + window.pageYOffset;
                    window.scrollTo({
                        top: topPos,
                        behavior: 'smooth'
                    })
                }, 200);
                document.querySelector('#handbook-content').focus();
            },
            navDrawerLinkFocus() {
                if (!this.drawer) {
                    this.drawer = !this.drawer;
                }
            }

        },
        components: {
            Drawer
        },

        //  OK, so below we prefetch and cache the primary data upon application initialisation
        created() {
            if (this.$store.state.OBJ_PARLIAMENTS.length == 0) {
                this.$store.dispatch('FETCH_PARLIAMENTS', {
                    url: this.$store.state.API_PARLIAMENTS,
                    mutation: 'OBJ_PARLIAMENTS'
                });
            }

            if (this.$store.state.OBJ_PARTIES.length == 0) {
                this.$store.dispatch('FETCH_PARTIES', {
                    url: this.$store.state.API_PARTIES,
                    mutation: 'OBJ_PARTIES'
                });
            }

            if (this.$store.state.OBJ_STATES.length == 0) {
                this.$store.dispatch('FETCH_STATES', {
                    url: this.$store.state.API_STATES,
                    mutation: 'OBJ_STATES'
                });
            }

            // No longer loading the below for performance reasons. Eac page loads its own data as necessary

            if (this.$store.state.OBJ_ELECTORATES.length == 0) {
                this.$store.dispatch('FETCH_ELECTORATES', {
                    url: this.$store.state.API_ELECTORATES,
                    mutation: 'OBJ_ELECTORATES'
                });
            }

            // if (this.$store.state.OBJ_PARLIAMENTARIANS.length == 0) {
            //     this.$store.dispatch('FETCH_PARLIAMENTARIANS', {
            //         url: this.$store.state.API_PARLIAMENTARIANS,
            //         mutation: 'OBJ_PARLIAMENTARIANS'
            //     })
            // }

            // if (this.$store.state.OBJ_RECORDSOFSERVICE.length == 0) {
            //     this.$store.dispatch('FETCH_RECORDSOFSERVICE', {
            //         url: this.$store.state.API_RECORDSOFSERVICE,
            //         mutation: 'OBJ_RECORDSOFSERVICE'
            //     })
            // }

            // if (this.$store.state.OBJ_MINISTRIES.length == 0) {
            //     this.$store.dispatch('FETCH_MINISTRIES', {
            //         url: this.$store.state.API_MINISTRIES,
            //         mutation: 'OBJ_MINISTRIES'
            //     })
            // }

            // if (this.$store.state.OBJ_MINISTRYRECORDS.length == 0) {
            //     this.$store.dispatch('FETCH_MINISTRYRECORDS', {
            //         url: this.$store.state.API_MINISTRYRECORDS,
            //         mutation: 'OBJ_MINISTRYRECORDS'
            //     });
            // }

            // if (this.$store.state.OBJ_SHADOWMINISTRIES.length == 0) {
            //     this.$store.dispatch('FETCH_SHADOWMINISTRIES', {
            //         url: this.$store.state.API_SHADOWMINISTRIES,
            //         mutation: 'OBJ_SHADOWMINISTRIES'
            //     })
            // }

            // if (this.$store.state.OBJ_SHADOWMINISTRYRECORDS.length == 0) {
            //     this.$store.dispatch('FETCH_SHADOWMINISTRYRECORDS', {
            //         url: this.$store.state.API_SHADOWMINISTRYRECORDS,
            //         mutation: 'OBJ_SHADOWMINISTRYRECORDS'
            //     })
            // }

            if (this.$store.state.OBJ_COMMITTEES.length == 0) {
                this.$store.dispatch('FETCH_COMMITTEES', {
                    url: this.$store.state.API_COMMITTEES,
                    mutation: 'OBJ_COMMITTEES'
                })
            }

            // if (this.$store.state.OBJ_COMMITTEERECORDS.length == 0) {
            //     this.$store.dispatch('FETCH_COMMITTEERECORDS', {
            //         url: this.$store.state.API_COMMITTEERECORDS,
            //         mutation: 'OBJ_COMMITTEERECORDS'
            //     });
            // }

            // if (this.$store.state.OBJ_COMMITTEERECORDS.length == 0) {
            //     this.$store.dispatch('FETCH_COMMITTEERECORDS', {
            //         url: this.$store.state.API_COMMITTEERECORDS,
            //         mutation: 'OBJ_COMMITTEERECORDS'
            //     });
            // }
            //if (this.$store.state.OBJ_DISTRIBUTIONS.length == 0) {
            //    this.$store.dispatch('FETCH_DISTRIBUTIONS', {
            //        url: this.$store.state.URL_DISTRIBUTIONS,
            //        mutation: 'OBJ_DISTRIBUTIONS'
            //    });
            //}
        },

        beforeMount() {
            const currentUrl = window.location.href;
            var cookie = this.$cookies.get('handbook_culturalSensitivityWarningSeen');

            //Cookie is set, or we are on the indigenous Australians page which has a popup of its own
            if (parseInt(cookie) === 1 || currentUrl.toLowerCase().indexOf('indigenous') > -1) {
                this.dialog = false;
            }
            else {
                this.dialog = true;
            }
        },
        computed: {
            title: function () {
                var title = 'Parliamentary Handbook';
                return title;
            },
            contentClass: function () {

                if (this.drawer) {
                    return "mainPadding shiftContent"
                }
                else {
                    return "mainPadding unshiftContent"
                }
            },
            handbookHelp: function () {

                let helpLink = this.helpLink;
                if (this.currentSection) {
                    helpLink = `${helpLink}#${this.currentSection}`
                }
                return helpLink;
            },
            currentSection: function () {
                let path = this.$route.path.toLowerCase();
                let section = '';
                if (path.includes('parliamentarian')) {
                    section = 'parliamentarians';
                } else if (path.includes('electorate')) {
                    section = 'electorates'
                } else if (path.includes('committee')) {
                    section = 'committees'
                } else if (path.includes('shadowministr')) {
                    section = 'shadowministries'
                } else if (path.includes('ministr')) {
                    section = 'ministries'
                } else if (path.includes('party')) {
                    section = 'parties'
                } else if (path.includes('advancedsearch')) {
                    section = 'advancedsearch'
                }

                return section;
            },
            headerImage: function () {
                let src = '/images/header-logo_icon.png';
                return src;
            },
            headerImageHeight: function () {
                let height = '50px';
                return height;
            }
        }
    }

</script>

<style>
    @media print {
        table tfoot {
            display: table-row-group;
        }
        .v-image__image {
            visibility: visible;
            print-color-adjust: exact;
            -webkit-print-color-adjust: exact;
        }
    }

    .handbook-link_link {
        cursor: pointer;
    }

    .logo-link {
        text-decoration: none;
    }

    .logo-link .handbook-link_link{
        color:white;
        text-decoration: none;
    }


    .handbook-helpPanel {
        background-color: #0e1531;
        width: 95px;
        border: solid 1px #0e1531;
        border-radius: 5px;
        height: 36px;
        position: fixed;
        top: 120px;
        right: -65px;
        z-index: 99;
        -webkit-box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
        box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
        text-decoration: none;
        text-align: left;
    }

    .handbook-helpPanel:hover {
        transform: translateX(-64px);
        transition: 0.2s;
        transition-timing-function: cubic-bezier(0.09,-0.71, 0.81, 1.6);
    }

    span.handbook-link_help {
        color: #fff;
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 0.02em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: 'Roboto', sans-serif;
        line-height: 1.5;
        text-align: left;
        padding-left: 4px;
    }

    span.handbook-link_help > i {
        text-decoration: none;
        font-size: 24px;
        color: #fff;
    }

    div.footer-items > div > a {
        color: #fff;
        text-decoration: none;
        cursor: pointer;
    }

    .shiftContent {
        transform: translateX(220px);
        width: calc(100% - 220px);
    }

    .unshiftContent {
        transform: translateX(0px);
        width: 100%;
    }

    .csvButton_hide {
        display: none !important;
    }

    .csvButton {
        float: right;
        margin-right: 0 !important;
    }

    @media screen and (min-width: 960px) {
        .mainPadding {
            padding: 85px 45px 45px 45px !important;
        }

        .small-screen_icon {
            display: none !important;
        }

        .large-screen_icon {
            display: flex !important;
        }
    }

    @media screen and (min-width: 600px) and (max-width: 959px) {
        .mainPadding {
            padding: 85px 10px 45px 10px !important;
        }

        .small-screen_icon {
            display: flex !important;
        }

        .large-screen_icon {
            display: none !important;
        }
    }

    @media only screen and (max-width: 599px) {
        .mainPadding {
            padding: 65px 10px 45px 10px !important;
        }

        .v-messages {
            min-height: 0px !important;
        }
    }

    @media only screen and (max-width: 440px) {
        .handbook-header-img {
            max-width: 60px !important;
            min-width: 60px !important;
        }

        .logo-link .v-toolbar__title {
            font-size: 17px;
        }

        .v-toolbar__title {
            overflow: visible !important;
        }

    }

    @media only screen and (max-width: 440px) {
        .handbook-header-img {
            max-width: 60px !important;
            min-width: 60px !important;
        }

        .logo-link .v-toolbar__title {
            font-size: 17px;
        }

        .v-toolbar__title {
            overflow: visible !important;
        }

       
    }

    

    .loader {
        border: 12px solid #a8a8a8; /* Light grey */
        border-top: 12px solid #facb45; /* Yellow */
        border-bottom: 12px solid #378bca; /* Blue */
        border-radius: 50%;
        width: 80px;
        height: 80px;
        animation: spin 2s linear infinite;
        margin: auto;
        border: 12px solid #d9d9d9;
        border-top: 12px solid #BE8E57;
        border-bottom: 12px solid #185293;
    }

    .loading {
        animation: spin 1.5s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(-360deg);
        }
    }

    .handbook-link_skipToContent {
        color: #f5f5ff;
        cursor: pointer;
        background-color: #0e1531;
        width: 110px;
        margin: auto;
    }

        .handbook-link_skipToContent:focus {
            transform: translateY(0%);
            z-index: 99;
        }

    .house-fill {
        background-color: #467664;
        border-color: #467664;
        color: #fff;
    }

    .senate-fill {
        background-color: #99504f;
        border-color: #99504f;
        color: #fff;
    }

    .joint-fill {
        background-color: #4275ae;
        border-color: #4275ae;
        color: #fff;
    }

    .theme--light.v-chip {
        background: #2e547e;
        color: #f5f5f5;
    }

    .v-datatable.theme--light.v-table thead th {
        color: rgb(14 21 49);
        font-size: 13px;
    }

    .theme--light.v-table {
        background-color: #fbfbfb;
    }

    .theme--light.v-table thead tr:first-child {
        background: #efefef;
    }

    .v-datatable .tr {
        display:table-row;
    }

    .v-datatable a.tr {
        color: #0e1531de;
        text-decoration:none;
        border: 1px solid #dbdbdb;
        border-left: none;
        border-right: none;
    }

    .v-datatable tbody td {
        vertical-align: middle;
    }


/* 
    @media screen and (max-width: 768px) {
      table.v-table .tr {
        max-width: 100%;
        position: relative;
        display: block;
      }

      table.v-table .tr td {
        display: flex;
        width: 100%;
        border-bottom: 1px solid #f5f5f5;
        height: auto;
        padding: 10px;
      }

      table.v-table .tr td ul li:before {
        content: attr(data-label);
        padding-right: .5em;
        text-align: left;
        display: block;
        color: #999;

      }
      .v-datatable__actions__select
      {
        width: 50%;
        margin: 0px;
        justify-content: flex-start;
      }
      .theme--light.v-table tbody .tr:hover:not(.v-datatable__expand-row) {
        background: transparent;
      }

    }
     */


     @media only screen and (min-width: 960px){
        .container {
            max-width: 100% !important;
        }
     }


    .handbook_iconButton.v-btn:focus{
        outline: 2px solid black;
    }

    .v-btn-toggle .v-btn:focus {
        opacity: 0.8 !important;
        outline: 2px solid black;
    }

    .v-btn:focus {
        outline: 2px solid black;
    }

    .v-datatable thead th.column.sortable:focus {
        text-decoration: underline;
        background-color: #cfcfcf;
    }

    .v-datatable a.tr:focus-visible {
        box-shadow: inset 0px 0px 0px 2px #000;
        outline: none;
    }

  /* @media screen and (max-width: 768px) { */
        .mobileDataTable table.v-table .tr,
        .mobileDataTable table.v-table tr {
            max-width: 100%;
            position: relative;
            display: block;
        }

        .mobileDataTable table.v-table .tr:nth-child(odd),
        .mobileDataTable table.v-table tr:nth-child(odd) {
            border-left: 4px solid #b3b3b3;
        }

        .mobileDataTable table.v-table .tr:nth-child(even),
        .mobileDataTable table.v-table tr:nth-child(even)  {
            border-left: 4px solid #cfcfcf;
        }

        .mobileDataTable table.v-table .tr td,
        .mobileDataTable table.v-table tr td {
            display: flex;
            width: 100%;
            border-bottom: 1px solid #f5f5f5;
            height: auto;
            padding: 10px;
        }

        .mobileDataTable table.v-table .tr td .flex-content .flex-item:before,
        .mobileDataTable table.v-table tr td .flex-content .flex-item:before {
            content: attr(data-label);
            padding-right: .5em;
            text-align: left;
            display: block;
            font-weight: bold;
            color: #424242;
        }

        .mobileDataTable .v-datatable__actions__select
        {
            width: 50%;
            margin: 0px;
            justify-content: flex-start;
        }

        .mobileDataTable .theme--light.v-table tbody .tr:hover:not(.v-datatable__expand-row),
        .mobileDataTable .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row),
        .mobileDataTable .theme--light.v-table tfoot .tr:hover:not(.v-datatable__expand-row),
        .mobileDataTable .theme--light.v-table tfoot tr:hover:not(.v-datatable__expand-row) {
            background: transparent;
        }

        .v-text-field.mobileTextField{
            display: inline-block;
            width: 68%;
        }

        .mobileDataTable tfoot tr {
            height:auto !important;
        }

        .mobileDataTable .flex-content {
            padding: 0;
            margin: 0;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            padding-bottom: 0.25rem;
        }

        .mobileDataTable .flex-content p {
            margin-bottom: 10px;
        }

        .mobileDataTable .flex-item {
            padding: 5px;
            width: 100%;
        }

        .mobileDataTable .flex-item ul {
            padding-left: 15px;
        }

        .mobileDataTable .flex-item-col {
            width: 50%;
            display: inline-block;
        }

        .mobileDataTable .flex-item-col-30 {
            width: 30%;
        }


        .mobileDataTable .flex-item-col-25 {
            width: 25%;
        }


        .mobileDataTable .flex-item-col-20 {
            width: 20%;
        }

        .mobileDataTable .flex-item-col-33 {
            width: 33.3%;
        }

        .mobileDataTable .flex-item-col-40 {
            width: 40%;
        }

        .mobileDataTable .flex-item-col-60 {
            width: 60%;
        }

        .mobileDataTable .flex-item-col-70 {
            width: 70%;
        }

        .mobileDataTable .flex-item-col-75 {
            width: 75%;
        }
    /* } */

     @media only print {
        .mobileDataTable table.v-table .tr td, .mobileDataTable table.v-table tr td {
            padding: 3px !important;
        }
        .mobileDataTable .flex-item {
            padding: 3px !important;
        }
        .mobileDataTable .flex-content {
            padding: 0 !important;
        }
        .page-break { page-break-before: always; }
     }

    .v-toolbar__title {
        overflow: visible;
    }
</style>
